import React from "react";
import { Form } from "antd";
import CheckboxGroupWithCheckAll from "./CheckboxGroupWithCheckAll";

export const OPTIONS = [
  { cls_code: "32", label: "기지국" },
  // {cls_code: "구현중1", label: "기지국(2G)"},
  // {cls_code: "구현중2", label: "기지국(3G)"},
  // {cls_code: "구현중3", label: "기지국(4G)"},
  { cls_code: "94", label: "간이무선국" },
  { cls_code: "44", label: "육상무선국" },
  { cls_code: "85", label: "이동중계국" },
  { cls_code: "49", label: "이동국" },
  { cls_code: "92", label: "아마추어국" },
  { cls_code: "42", label: "의무선박국" },
  { cls_code: "41", label: "선박국" },
  { cls_code: "21", label: "고정국" },
  { cls_code: "CMFL", label: "전파응용설비" },
  { cls_code: "OTHER", label: "기타" },
  { cls_code: "5g", label: "5G" },
];

function WidgetClsCodeForStats() {
  return (
    <Form.Item>
      <CheckboxGroupWithCheckAll
        title="무선국종"
        fieldName={"cls_code_stats_list"}
        options={OPTIONS.map(({ cls_code, label }) => ({
          value: cls_code,
          label,
        }))}
        colSpan={12}
      />
    </Form.Item>
  );
}

export default WidgetClsCodeForStats;
